import React from "react";
import ContentLoader from "react-content-loader";
import { Container } from "./styles";
import { FiUsers, FiPlus, FiSearch } from "react-icons/fi";

const UsersLoadingSkeleton = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  // Cores comerciais vibrantes para os avatares
  const avatarColors = [
    '#3b82f6', // Azul vibrante
    '#10b981', // Verde
    '#f59e0b', // Laranja
    '#8b5cf6', // Roxo
    '#ef4444', // Vermelho
    '#06b6d4', // Ciano
  ];

  return (
    <Container>
      {/* Header Info - mantém como está */}
      <div className="header-info">
        <div className="header-icon">
          <FiUsers />
        </div>
        <div className="header-details">
          <h3>Gerenciamento de Usuários</h3>
          <div className="header-meta">
            <span className="status-tag active">Sistema Online</span>
            <span className="update-tag">Carregando...</span>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="header-stats">
        {[...Array(5)].map((_, i) => (
          <div key={`stat-${i}`} className="stat-card">
            <div className="stat-icon">
              <ContentLoader
                speed={2}
                width={24}
                height={24}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="4" ry="4" width="24" height="24" />
              </ContentLoader>
            </div>
            <div className="stat-content">
              <p className="stat-value">
                <ContentLoader
                  speed={2}
                  width={40}
                  height={24}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="4" ry="4" width="40" height="24" />
                </ContentLoader>
              </p>
              <p className="stat-label">
                <ContentLoader
                  speed={2}
                  width={120}
                  height={13}
                  backgroundColor={backgroundColor}
                  foregroundColor={foregroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="120" height="13" />
                </ContentLoader>
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Toolbar */}
      <div className="toolbar">
        <div className="toolbar-left">
          {['Todos', 'Administradores', 'Usuários'].map((label, i) => (
            <button
              key={`filter-${i}`}
              className={`filter-btn ${i === 0 ? 'active' : ''}`}
            >
              <ContentLoader
                speed={2}
                width={label.length * 7}
                height={13}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="3" ry="3" width={label.length * 7} height="13" />
              </ContentLoader>
            </button>
          ))}
          <div className="search-input">
            <FiSearch />
            <ContentLoader
              speed={2}
              width={200}
              height={14}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              <rect x="0" y="0" rx="3" ry="3" width="200" height="14" />
            </ContentLoader>
          </div>
        </div>
        <div className="toolbar-right">
          <button className="btn-new-user">
            <FiPlus />
            <ContentLoader
              speed={2}
              width={90}
              height={14}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
              style={{ marginLeft: '8px' }}
            >
              <rect x="0" y="0" rx="3" ry="3" width="90" height="14" />
            </ContentLoader>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Users Grid */}
        <div className="users-container">
          <div className="users-grid">
            {[...Array(8)].map((_, i) => (
              <div key={`user-${i}`} className="user-card">
                {/* User Card Header */}
                <div className="user-card-header">
                  <div className="user-avatar">
                    <div 
                      className="avatar-circle" 
                      style={{ 
                        background: avatarColors[i % avatarColors.length],
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
                      }}
                    >
                      <ContentLoader
                        speed={2}
                        width={32}
                        height={20}
                        backgroundColor="rgba(255, 255, 255, 0.2)"
                        foregroundColor="rgba(255, 255, 255, 0.3)"
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="32" height="20" />
                      </ContentLoader>
                    </div>
                  </div>
                  <div className="user-info">
                    <h5>
                      <ContentLoader
                        speed={2}
                        width={120}
                        height={16}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="120" height="16" />
                      </ContentLoader>
                    </h5>
                    <p className="user-email">
                      <ContentLoader
                        speed={2}
                        width={160}
                        height={12}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="160" height="12" />
                      </ContentLoader>
                    </p>
                  </div>
                </div>

                {/* User Card Body */}
                <div className="user-card-body">
                  <div className="user-meta">
                    <span className="role-badge">
                      <ContentLoader
                        speed={2}
                        width={90}
                        height={22}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="6" ry="6" width="90" height="22" />
                      </ContentLoader>
                    </span>
                    <span className="last-access">
                      <ContentLoader
                        speed={2}
                        width={150}
                        height={11}
                        backgroundColor={backgroundColor}
                        foregroundColor={foregroundColor}
                      >
                        <rect x="0" y="0" rx="3" ry="3" width="150" height="11" />
                      </ContentLoader>
                    </span>
                  </div>

                  {/* Permission Badges */}
                  <div className="user-permissions-badges">
                    {[...Array(5)].map((_, j) => (
                      <div key={`badge-${j}`} className="badge" data-access="true">
                        <ContentLoader
                          speed={2}
                          width={12}
                          height={12}
                          backgroundColor={backgroundColor}
                          foregroundColor={foregroundColor}
                        >
                          <rect x="0" y="0" rx="3" ry="3" width="12" height="12" />
                        </ContentLoader>
                      </div>
                    ))}
                  </div>
                </div>

                {/* User Card Footer */}
                <div className="user-card-footer">
                  <button className="btn-edit">
                    <ContentLoader
                      speed={2}
                      width={60}
                      height={13}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="60" height="13" />
                    </ContentLoader>
                  </button>
                  <button className="btn-delete">
                    <ContentLoader
                      speed={2}
                      width={60}
                      height={13}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="60" height="13" />
                    </ContentLoader>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default UsersLoadingSkeleton;
